import React, { useContext, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Box,
  Grid,
  TextField,
  Button,
  // IconButton,
  Paper,
} from "@material-ui/core";
// import CloseIcon from '@material-ui/icons/Close';
import Autocomplete from "@material-ui/lab/Autocomplete";
import PageHeadingCreate from "../../../components/PageHeadingCreate";
import PathsandTitle from "../../../common/constants/PathsandTitle";
import MasterdataContext from "../../../common/contexts/MasterdataContext";
import AutocompleteController from "../../../components/AutoCompleteController";
import FormValidationErrorMessage from "../../../components/FormValidationErrorMessage";
import {
  update_department_master,
  get_department_master_by_id,
  list_warehouse_master,
} from "../../../common";
import useStyles from "../../../themes/makeStyles";
import ActionTypes from "../../../common/constants/ActionTypes";
import Notification from "../../../components/Notifications/index.js";
import clsx from "clsx";
import { useHistory } from "react-router-dom";

export default function EditDepartmentMaster(props) {
  const { masterdata } = useContext(MasterdataContext);
  const [resetvalues, setResetvalues] = React.useState(false);
  const [warehouseNames, setWarehouseNames] = React.useState([]);
  const warehouseData =
    JSON.parse(sessionStorage.getItem("warehouseData")) || {};
  const userData = JSON.parse(sessionStorage.getItem("login")) || {};

  const [notify, setNotify] = React.useState({
    isOpen: false,
    message: "",
    type: "",
    timing: "",
  });

  let department_id = props.location.department_id;

  let defaultValues = {
    department_id: department_id,
    department_name: "",
    contact_type: "",
    contact_name: "",
    contact_number: "",
    customer_name: null,
    email_id: "",
    warehouse_code: [],
  };

  const { handleSubmit, reset, setValue, control, errors } = useForm({
    defaultValues,
  });

  useEffect(() => {
    if (department_id) {
      get_department_master_by_id({
        department_id: department_id.toString(),
      }).then((data) => {
        setValue("department_id", data.Records[0].department_id);
        setValue("department_name", data.Records[0].department_name);
        setValue("contact_type", data.Records[0].contact_type);

        setValue("customer_name", {
          customer_name: data.Records[0].customer_name,
        });
        setValue("contact_name", data.Records[0].contact_name);
        setValue("contact_number", data.Records[0].contact_number);
        setValue("email_id", data.Records[0].email_id);
        list_warehouse_master().then((whmaster) => {
          setWarehouseNames(whmaster.Records);
          stringstoArray(data.Records[0].warehouse_code, whmaster.Records);
        });
      });
    }
  }, []);

  const stringstoArray = (data, masterwh) => {
    const nameArr = data.split(",");

    const whnames = [];

    for (let code of nameArr) {
      for (let whname of masterwh) {
        if (code === whname.warehouse_code) {
          whnames.push(whname);
        }
      }
    }

    const objs = whnames;
    setValue("warehouse_code", objs);
  };

  const history = useHistory();

  const CustomerProps = {
    options: masterdata.CustomerDetails ? masterdata.CustomerDetails : [],
    getOptionLabel: (option) => option.customer_name,
  };

  const onSubmit = async (data) => {
    let postobj = {
      department_name: data.department_name,
      contact_type: data.contact_type,
      customer_name: data.customer_name.customer_name,
      contact_name: data.contact_name,
      contact_number: data.contact_number,
      email_id: data.email_id,
      // warehouse_location: warehouseData.warehouse_location,
      warehouse_code: data.warehouse_code
        ? data.warehouse_code.map((obj) => obj.warehouse_code).join(",")
        : "",
      // warehouse_code: warehouseData.warehouse_code,
      // createdby: userData.login,
      updatedby: userData.name,
      record_type_status: "a",
    };

    let departmentMasterUpdateDeatils = await update_department_master(
      { department_id: department_id },
      postobj
    );

    if (departmentMasterUpdateDeatils.issuccess === 1) {
      setNotify({
        isOpen: true,
        message: `Department Master Updated Successfully `,
        type: "success",
        timing: 3000,
      });
      setTimeout(function () {
        history.push(`/${ActionTypes.LOB}/masters/list-department-master`);
      }, 3000);
    } else if (departmentMasterUpdateDeatils.issuccess === 0) {
      if (
        departmentMasterUpdateDeatils.errorcode === "23505" &&
        departmentMasterUpdateDeatils.constraint ===
          "department_master_customer_name_key"
      ) {
        setNotify({
          isOpen: true,
          message: `Customer Name already exists`,
          type: "error",
          timing: 3000,
        });
      }
    }
  };

  const validateEmail = (email) => {
    // const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePhone = (number) => {
    const phoneno = /^\d{10}$/;
    return phoneno.test(String(number).toLowerCase());
  };

  //return here
  const classes = useStyles();
  return (
    <React.Fragment>
      <PageHeadingCreate
        headingtitle={PathsandTitle.PathsHeading.editDepartment}
        headingpath={PathsandTitle.TitlesNavigation.departmentName}
        pageStatus="Update"
        pagePath="Update Department Master"
      />
      <Box py={1}>
        <form onSubmit={handleSubmit(onSubmit)} noValidate key={resetvalues}>
          <Paper elevation={0}>
            <Box py={4} px={3}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} spacing={2}>
                  <Controller
                    as={<TextField />}
                    label="Department ID"
                    placeholder="Department ID"
                    margin="normal"
                    type="text"
                    variant="outlined"
                    disabled
                    size="small"
                    name="department_id"
                    id="department_id"
                    error={errors.department_id}
                    fullWidth
                    required
                    rules={{ required: true }}
                    control={control}
                  />
                  {errors.department_id && (
                    <FormValidationErrorMessage
                      errors={errors}
                      errorMessagePrefix="Department ID"
                      name="department_id"
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={4} spacing={2}>
                  <Controller
                    as={<TextField />}
                    label="Department Name"
                    placeholder="Department Name"
                    margin="normal"
                    type="text"
                    variant="outlined"
                    size="small"
                    name="department_name"
                    id="department_name"
                    error={errors.department_name}
                    fullWidth
                    required
                    rules={{ required: true }}
                    control={control}
                  />
                  {errors.department_name && (
                    <FormValidationErrorMessage
                      errors={errors}
                      errorMessagePrefix="Department Name"
                      name="department_name"
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={4} spacing={2}>
                  <AutocompleteController
                    name="customer_name"
                    control={control}
                    Values={CustomerProps}
                    required={true}
                    disabled={false}
                    error={errors.customer_name}
                    rules={{ required: true }}
                    id="customer_name"
                    label="Customer Name"
                  />
                  {errors.customer_name && (
                    <FormValidationErrorMessage
                      errors={errors}
                      errorMessagePrefix="Customer Name"
                      name="customer_name"
                    />
                  )}
                </Grid>

                <Grid item xs={12} sm={4} spacing={2}>
                  <Controller
                    as={<TextField />}
                    label="Contact Type"
                    placeholder="Contact Type"
                    margin="normal"
                    type="text"
                    variant="outlined"
                    size="small"
                    name="contact_type"
                    id="contact_type"
                    error={errors.contact_type}
                    fullWidth
                    required
                    rules={{ required: true }}
                    control={control}
                  />
                  {errors.contact_type && (
                    <FormValidationErrorMessage
                      errors={errors}
                      errorMessagePrefix="Contact Type"
                      name="contact_type"
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={4} spacing={2}>
                  <Controller
                    as={<TextField />}
                    label="Contact Name"
                    placeholder="Contact Name"
                    margin="normal"
                    type="text"
                    variant="outlined"
                    size="small"
                    name="contact_name"
                    id="contact_name"
                    error={errors.contact_name}
                    fullWidth
                    required
                    rules={{ required: true }}
                    control={control}
                  />
                  {errors.contact_name && (
                    <FormValidationErrorMessage
                      errors={errors}
                      errorMessagePrefix="Contact Name"
                      name="contact_name"
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={4} spacing={2}>
                  <Controller
                    as={<TextField />}
                    label="Contact Number"
                    placeholder="Contact Number"
                    margin="normal"
                    type="text"
                    variant="outlined"
                    size="small"
                    name="contact_number"
                    id="contact_number"
                    error={errors.contact_number}
                    fullWidth
                    required
                    //  rules={{ required: true }}
                    rules={{
                      validate: (value) => validatePhone(value),
                    }}
                    control={control}
                  />
                  {errors.contact_number && (
                    <FormValidationErrorMessage
                      errors={errors}
                      errorMessagePrefix="Contact Number"
                      name="contact_number"
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={4} spacing={2}>
                  <Controller
                    as={<TextField />}
                    label="Contact E-Mail Id"
                    placeholder="Contact E-Mail Id"
                    margin="normal"
                    type="text"
                    variant="outlined"
                    size="small"
                    name="email_id"
                    id="email_id"
                    error={errors.email_id}
                    fullWidth
                    required
                    //  rules={{ required: true }}

                    rules={{
                      validate: (value) => validateEmail(value),
                    }}
                    control={control}
                  />
                  {errors.email_id && (
                    <FormValidationErrorMessage
                      errors={errors}
                      errorMessagePrefix="Contact E-Mail Id"
                      name="email_id"
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={4} spacing={2}>
                  <Controller
                    as={<Autocomplete />}
                    multiple
                    options={warehouseNames}
                    disableCloseOnSelect
                    name="warehouse_code"
                    getOptionLabel={(option) => option.warehouse_name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        label="Warehouse Names"
                        placeholder="Warehouse Names"
                        margin="normal"
                        required
                      />
                    )}
                    onChange={([, data]) => {
                      try {
                      } catch {}

                      return data;
                    }}
                    control={control}
                    rules={{
                      validate: (data) => {
                        if (data.length === 0) return false;
                      },
                    }}
                  />
                  {errors.warehouse_name && (
                    <FormValidationErrorMessage
                      errors={errors}
                      errorMessagePrefix="Warehouse Names"
                      name="warehouse_code"
                    />
                  )}
                </Grid>
              </Grid>
            </Box>
          </Paper>

          <Box py={2}>
            <Grid container justify="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={clsx(
                    classes.subTextButton,
                    "mr-0",
                    "btnMinWidthSearch"
                  )}
                >
                  Update
                </Button>
              </Grid>
            </Grid>
          </Box>
        </form>

        <Notification notify={notify} setNotify={setNotify} />
      </Box>
    </React.Fragment>
  );
}
